import IBModuleApi from "../../../api/rolecatalogAPI";
import { urlContexts } from "../../../constants";

export const getStatus = async () => {
  const { data } = await IBModuleApi.get(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/status`
  );

  return data;
};
